import { render } from "./DataViewerPreviewSentTemplate.vue?vue&type=template&id=5e749468"
import script from "./DataViewerPreviewSentTemplate.vue?vue&type=script&lang=ts"
export * from "./DataViewerPreviewSentTemplate.vue?vue&type=script&lang=ts"
script.render = render

export default script